// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DistributionFormat
 */
export interface DistributionFormat {
  /**
   *
   */
  name: string;
  /**
   *
   */
  version?: string | null;
  /**
   *
   */
  specification?: string | null;
}

/**
 * Check if a given object implements the DistributionFormat interface.
 */
export function instanceOfDistributionFormat(value: object): value is DistributionFormat {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function DistributionFormatFromJSON(json: any): DistributionFormat {
  return DistributionFormatFromJSONTyped(json, false);
}

export function DistributionFormatFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DistributionFormat {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    version:
      json["version"] === undefined ? undefined : json["version"] === null ? null : json["version"],
    specification:
      json["specification"] === undefined
        ? undefined
        : json["specification"] === null
        ? null
        : json["specification"],
  };
}

export function DistributionFormatToJSON(json: any): DistributionFormat {
  return DistributionFormatToJSONTyped(json, false);
}

export function DistributionFormatToJSONTyped(
  value?: DistributionFormat | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    version: value["version"],
    specification: value["specification"],
  };
}
